import React, { useEffect } from "react";
import HostNav from "../components/hostComponents/HostNav";
import ProfileComponent from "../components/hostComponents/ProfileComponent";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { profileUpdateReset } from "../store/slices/hostSlices";
import { getFlags, getHostProfile } from "../store/thunks/hostActions";
import { Alert } from "@mui/material";

function ProfileSettingScreen() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const { Info } = useSelector((state) => state.hostDetails);

  const { hostInfo: hostLogin } = useSelector((state) => state.host);

  const {
    success: successUpdate,
    message: messageUpdate,
    error: errorUpdate,
  } = useSelector((state) => state.hostUpdate);

  useEffect(() => {
    if (!hostLogin) {
      navigate("/login");
    }
    if (successUpdate || hostLogin._id !== params.hid) {
      dispatch(getHostProfile(hostLogin._id));
    }

    dispatch(getHostProfile(hostLogin._id));
  }, [navigate, hostLogin, successUpdate, dispatch, params.hid]);

  useEffect(() => {
    if (successUpdate || errorUpdate) {
      dispatch(getHostProfile(hostLogin._id));

      setTimeout(() => {
        dispatch(profileUpdateReset());
      }, 2000);
    }
  }, [successUpdate, errorUpdate, dispatch]);

  useEffect(() => {
    if (hostLogin?._id) {
      dispatch(getFlags(hostLogin._id));
    }
  }, [dispatch, hostLogin?._id]);
  return (
    <div className="min-h-screen bg-white">
      <div className="flex flex-col w-full min-h-screen">
        <HostNav edit={true} />

        <main className="flex-1 overflow-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="max-w-4xl mx-auto">
            {errorUpdate && (
              <Alert severity="error" className="mb-4 rounded-xl">
                <strong>{errorUpdate}</strong>
              </Alert>
            )}

            {successUpdate && (
              <Alert severity="success" className="mb-4 rounded-xl">
                <strong>{messageUpdate}</strong>
              </Alert>
            )}

            <ProfileComponent
              Info={Info}
              errorUpdate={errorUpdate}
              successUpdate={successUpdate}
            />
          </div>
        </main>
      </div>
    </div>
  );
}

export default ProfileSettingScreen;
